import { AdminView } from '@pages/admin-view/admin-view-routes.names';
import { ExportId } from '@pages/share/share-routes.names';

export const ExportAppointments = 'export-appointments';

export const AdminExportAppointments = `${AdminView}/${ExportAppointments}`;
export const AdminExportAppointmentsWithParam = `${AdminView}/${ExportAppointments}?${ExportId}=:${ExportId}`;
